import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const CancelBookingModal = ({ show, bookingId, onCancel, onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Cancellation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to cancel this booking?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          No, Keep
        </Button>
        <Button variant="danger" onClick={() => onCancel(bookingId)}>
          Yes, Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelBookingModal;
